import React, { useEffect, useState } from 'react';
import {
  Paper,
  List,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography
} from '@mui/material';

/**
 * Return HTML for list of checkBox
 *
 * @param param0 contain is {url, selected url value }
 *
 * @returns HTML string
 */
const CheckboxSiteList = ({ data, selectedValues, scans, isInfo = false }) => {
  const [checklistValues, setChecklistValues] = useState([]);
  const [uncheckedValues, setUncheckedValues] = useState([]); // Unchecked values
  const [disable, setDisable] = useState(false);
  const newScans = data?.length - scans;
  // Handel check box change event
  const handleChange = (event) => {
    if (event?.target?.checked) {
      setChecklistValues([...checklistValues, event.target.value]);
      setUncheckedValues(
        uncheckedValues.filter((item) => item !== event?.target?.value)
      );
    } else {
      setChecklistValues(
        checklistValues.filter((item) => item !== event?.target?.value)
      );
      setUncheckedValues([...uncheckedValues, event?.target?.value]);
    }
  };

  // Send to child to parent selected value
  useEffect(() => {
    //if (checklistValues.length == scans) {
    if (checklistValues.length >= newScans) {
      setDisable(true);
    } else {
      setDisable(false);
    }
    selectedValues(checklistValues);
  }, [checklistValues]);

  return (
    <Paper
      style={{
        maxHeight: data.length > 50 ? 150 : 'auto',
        overflowX: 'hidden',
        height: isInfo ? '107px' : '200px',
        overflowY: 'auto',
        boxShadow: 'none',
        scrollbarWidth: 'thin',
        scrollbarColor: 'lightgray transparent',
        backgroundColor: isInfo ? 'var(--color-bg-muted-alt)' : '',
        borderRadius: isInfo ? '0px' : ''
      }}
      className={isInfo ? '' : 'pl-2'}
    >
      <List>
        <FormGroup>
          {data.map((checkboxLabel, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  size="small"
                  disabled={disable && !checklistValues.includes(checkboxLabel)}
                  onChange={handleChange}
                  value={checkboxLabel}
                  checked={checklistValues.includes(checkboxLabel)}
                  sx={{
                    paddingTop: isInfo ? '4px' : '9px',
                    paddingBottom: isInfo ? '4px' : '9px',
                    transform: isInfo ? 'scale(1)' : 'scale(1)', // Reduce checkbox size further
                    '& .MuiSvgIcon-root': {
                      fontSize: isInfo ? '1rem' : '1.25rem' // Reduce the checkbox icon size
                    },
                    '&:hover': isInfo ? { backgroundColor: 'transparent' } : {} // Remove hover effect
                  }}
                  disableRipple={isInfo}
                />
              }
              label={
                <React.Fragment>
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      fontSize: isInfo ? '12px' : '15px',
                      fontWeight: '400 !important',
                      lineHeight: 'var(--line-height-16)',
                      textSlign: 'left',
                      color: 'var(--color-primary)',
                      letterSpacing: isInfo ? '0.3px' : ''
                    }}
                  >
                    {checkboxLabel}
                  </Typography>
                </React.Fragment>
              }
            />
          ))}
        </FormGroup>
      </List>
    </Paper>
  );
};

export default CheckboxSiteList;
